export default "assets/images/icons/soundcloud-1dbf96b8.svg";